import { gql } from '@apollo/client';

export const GET_AMCR_VOCABULARIES_QUERY = gql`
  query GetAmcrVocabularies {
    getAmcrVocabularies {
      types {
        id
        label
        key
        group
      }
      materials {
        id
        label
        key
        group
      }
      eras {
        id
        label
        key
        group
      }
      contexts {
        id
        label
        key
        group
      }
    }
  }
`;
